<template>
  <RouterView />
</template>

<script setup>
import { watch, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useTokenStore, useEnvStore } from '@/stores'
import { getHttpsAddress } from '@/utils/index'

const { setToken, setRefreshtoken } = useTokenStore()
const { setEnv, removeAll } = useEnvStore()

const router = useRouter()
const route = useRoute()

// 监听路由变化，实时同步状态给 APP
// watch(
//   () => route.path,
//   (newPath) => {
//     if (!newPath) return

//     // 1. 严格对齐 APP 端的兜底策略
//     // 当处于这些根页面时，点击返回键 APP 应该直接放行并关闭 WebView
//     const rootPaths = ['/', '/home', '/login']
//     const isRootPage = rootPaths.includes(newPath)

//     // canBack 为 true 时表示需要拦截并执行内部返回，false 表示在首页直接退出
//     const needAppIntercept = !isRootPage

//     let attempts = 0
//     const maxAttempts = 50 // 最多尝试探测 1.5 秒

//     const tryPostMessage = () => {
//       attempts++

//       if (window.uni && typeof window.uni.postMessage === 'function') {
//         window.uni.postMessage({
//           payload: JSON.stringify({
//             action: 'updateHistory',
//             canBack: needAppIntercept,
//             currentPath: newPath
//           })
//         })
//         console.log(`🚀 [H5上报成功] 路径: ${newPath} | 拦截状态: ${needAppIntercept}`)
//       } else {
//         if (attempts < maxAttempts) {
//           setTimeout(tryPostMessage, 30)
//         } else {
//           console.error('❌ [H5上报失败] window.uni.postMessage 通道未就绪')
//         }
//       }
//     }

//     // 路由变更，立即启动探测链
//     tryPostMessage()
//   },
//   { immediate: true }
// )

onMounted(() => {
  removeAll()
  // 获取网址中的参数
  const token = new URL(window.location.href).searchParams.get('token')
  const refreshtoken = new URL(window.location.href).searchParams.get('refreshtoken')
  const env = new URL(window.location.href).searchParams.get('env')

  getHttpsAddress()

  if (token) {
    setEnv('app')
    localStorage.setItem('userToken', JSON.stringify({ token, refreshtoken }))
    setToken(token)
    setRefreshtoken(refreshtoken)
  } else if (env == 'js') {
    setEnv('js')
    router.push({ path: '/login' })
  } else {
    setEnv('js')
  }
})
</script>

<style scoped lang="scss"></style>
